module.exports = __webpack_public_path__ + "static/media/fiverr.853efcc2.png";